import surf1 from "../../media/surf1.mp4";
import surf2 from "../../media/surf2.mp4";
import surf3 from "../../media/surf3.mp4";
import surf4 from "../../media/surf4.mp4";
import surf5 from "../../media/surf5.mp4";
import surf6 from "../../media/surf6.mp4";
import surf7 from "../../media/surf7.mp4";
import surf8 from "../../media/surf8.mp4";
import surf9 from "../../media/surf9.mp4";
import surf10 from "../../media/surf10.mp4";

export const surfVideos = [
  {
    index: 0,
    tag: "videos",
    title: "Cool waves",
    video: surf1,
  },

  {
    index: 1,
    tag: "videos",
    title: "The Best Surf Spots around",
    video: surf2,
  },

  {
    index: 2,
    tag: "videos",
    title: "Surfing in paradise",
    video: surf3,
  },

  {
    index: 3,
    tag: "videos",
    title: "Video of the day ",
    video: surf4,
  },

  {
    index: 4,
    tag: "videos",
    title: "Teahupo'o, Tahiti",
    video: surf5,
  },

  {
    index: 5,
    tag: "videos",
    title: "Top 10 waves of the swell",
    video: surf6,
  },

  {
    index: 6,
    tag: "videos",
    title: "Uluwatu Beach, Bali",
    video: surf7,
  },

  {
    index: 7,
    tag: "videos",
    title: "Monster waves in Nazare",
    video: surf8,
  },

  {
    index: 8,
    tag: "videos",
    title: "Relax and check out this amazing waves",
    video: surf9,
  },

  {
    index: 9,
    tag: "videos",
    title: "Great tubes in Australia",
    video: surf10,
  },
];
